// @flow strict

import { Button, Descriptions, Divider, Modal, Tooltip, message } from 'antd';
import React, { useState } from 'react';
import { BiSolidEditAlt } from "react-icons/bi";
import { FaEye } from "react-icons/fa6";
import { MdDelete } from "react-icons/md";
import { deleteReferRule } from '../../../../api/refer';
import UpdateRedeemRule from './UpdateRule';

function SingleRule({ rule, setReferRules }) {
  const [openView, setOpenView] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const [isDelete, setIsDelete] = useState(false);

  const handleClickDelete = () => {
    Modal.confirm({
      title: 'Delete Rule',
      content: 'Are you sure you want to delete this rule?',
      okText: 'Delete',
      cancelText: 'Cancel',
      onOk: handleDeleteRule,
      loading: isDelete,
    });
  };

  const handleDeleteRule = async () => {
    setIsDelete(true);

    try {
      const res = await deleteReferRule(rule?._id);
      if (res.data?.status === "success") {
        message.success(res.data?.message);
        setReferRules((prev) => {
          const temp = JSON.parse(JSON.stringify(prev));
          const index = temp.findIndex((item) => item._id === rule?._id);
          temp.splice(index, 1);
          return temp;
        });
      };
    } catch (error) {
      message.error(error?.message);
    } finally {
      setIsDelete(false);
    }
  };

  return (
    <>
      <div className="gap-2 d-flex justify-content-center">
        <Tooltip title="View Rule" color="grey">
          <Button onClick={() => setOpenView(true)}>
            <FaEye size={16} />
          </Button>
        </Tooltip>
        <Tooltip title="Update Rule" color="cyan">
          <Button onClick={() => setUpdateModal(true)}>
            <BiSolidEditAlt size={16} />
          </Button>
        </Tooltip>
        <Tooltip title="Delete Rule" color="red">
          <Button
            danger
            onClick={handleClickDelete}
          >
            <MdDelete size={16} />
          </Button>
        </Tooltip>
      </div>

      <Modal
        title="Update Referral Rule"
        open={updateModal}
        onCancel={() => setUpdateModal(false)}
        footer={false}
      >
        <UpdateRedeemRule
          setReferRules={setReferRules}
          rule={rule}
          setUpdateModal={setUpdateModal}
        />
      </Modal>

      <Modal
        title="Referral Rule Details"
        open={openView}
        onCancel={() => setOpenView(false)}
        footer={false}
      >
        <Divider />
        <Descriptions column={1}>
          <Descriptions.Item label="Points">
            {rule?.points}
          </Descriptions.Item>
          <Descriptions.Item label="Chat Token">
            {rule?.token}
          </Descriptions.Item>
          <Descriptions.Item label="Day Extend">
            {rule?.days || 0}
          </Descriptions.Item>
          <Descriptions.Item label="Assistant Limit">
            {rule?.assistant || 0}
          </Descriptions.Item>
          <Descriptions.Item className='text-capitalize' label="Chat Providers">
            {rule?.chat_providers?.length > 0 ? rule?.chat_providers?.join(', ') : '[ ]'}
          </Descriptions.Item>
          <Descriptions.Item label="Max File Upload">
            {rule?.max_file || 0}
          </Descriptions.Item>
          <Descriptions.Item label="User Limit">
            {rule?.user || 0}
          </Descriptions.Item>
          <Descriptions.Item label="Advance Parameter">
            {rule?.advance_parameter ? "Yes" : "No"}
          </Descriptions.Item>
          <Descriptions.Item label="Customize Chat">
            {rule?.customize_chat ? "Yes" : "No"}
          </Descriptions.Item>
        </Descriptions>
      </Modal>
    </>
  );
};

export default SingleRule;